import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAnglesDown,
  faAnglesUp,
  faArrowLeft,
  faArrowTrendUp,
  faArrowUpRightFromSquare,
  faAt,
  faBars,
  faBriefcase,
  faBullhorn,
  faCalculator,
  faCalendarDays,
  faChevronDown,
  faChevronLeft,
  faChevronUp,
  faCirclePlus,
  faCircleQuestion,
  faCircleXmark,
  faCopy,
  faDownload,
  faEarthAmericas,
  faEllipsisVertical,
  faEnvelope,
  faEye,
  faEyeSlash,
  faFax,
  faFileExclamation,
  faFloppyDisk,
  faHouse,
  faLaptop,
  faLink,
  faLock,
  faMagnifyingGlass,
  faMemo,
  faMobile,
  faMoneyBill,
  faPencil,
  faPeopleGroup,
  faPhone,
  faScaleUnbalancedFlip,
  faStar,
  faTableCells,
  faTag,
  faThumbsDown,
  faThumbsUp,
  faTrashCan,
  faTriangleExclamation,
  faUser,
  faUsers,
  faWindow,
  faXmark,
} from '@fortawesome/pro-regular-svg-icons';
import {
  faBuildings as fasBuildings,
  faCircleCheck as fasCircleCheck,
  faCirclePlus as fasCirclePlus,
  faCrown as fasCrown,
  faStar as fasStar,
} from '@fortawesome/pro-solid-svg-icons';

export default library.add(
  faAnglesDown,
  faAnglesUp,
  faArrowLeft,
  faArrowTrendUp,
  faArrowUpRightFromSquare,
  faAt,
  faBars,
  faBriefcase,
  fasBuildings,
  faBullhorn,
  faCalculator,
  faCalendarDays,
  faChevronDown,
  faChevronLeft,
  faChevronUp,
  faCirclePlus,
  faCircleQuestion,
  faCircleXmark,
  faCopy,
  faDownload,
  faEarthAmericas,
  faEllipsisVertical,
  faEnvelope,
  faEye,
  faEyeSlash,
  faFax,
  faFileExclamation,
  faFloppyDisk,
  faHouse,
  faLaptop,
  faLink,
  faLock,
  faMagnifyingGlass,
  faMemo,
  faMobile,
  faMoneyBill,
  faPencil,
  faPeopleGroup,
  faPhone,
  faScaleUnbalancedFlip,
  faStar,
  faTableCells,
  faTag,
  faThumbsDown,
  faThumbsUp,
  faTrashCan,
  faTriangleExclamation,
  faUser,
  faUsers,
  faWindow,
  faXmark,
  fasCircleCheck,
  fasCirclePlus,
  fasCrown,
  fasStar
);
